import { useQuery } from '@tanstack/react-query';

import { keysToCamel } from '@shared/helpers/snakeToCamel';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

import { getBankPaymentParsers } from '../model/api/getBankPaymentParsers';
import { IBankPaymentParsers, IBankPaymentParsersDTO } from '../model/types/types';

export const useGetBankPaymentParsersQuery = () => {
    const { isLoading, isFetching, data, isSuccess } = useQuery<
        IDataResponse<IBankPaymentParsersDTO>,
        Error,
        IBankPaymentParsers[]
    >({
        queryKey: ['bankPaymentParsers'],
        queryFn: getBankPaymentParsers,
        staleTime: 1000 * 60 * 5,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        select: (response: IDataResponse<IBankPaymentParsersDTO[]>) => keysToCamel(response.data),
    });

    return { isLoading, isFetching, isSuccess, data };
};
